import { useSyncExternalStore } from 'react';
import {
  getTextSizeLevelSnapshot,
  setTextSizeLevel,
  subscribeTextSizeLevel,
  type TextSizeLevelId,
} from '../services/textSizePreference';

/**
 * 全画面共通の文字の大きさの段階と、変更する関数を返す
 * @returns {readonly [TextSizeLevelId, (levelId: TextSizeLevelId) => void]} 現在の段階と変更関数
 */
const useTextSizeLevel = (): readonly [TextSizeLevelId, (levelId: TextSizeLevelId) => void] => [
  useSyncExternalStore(subscribeTextSizeLevel, getTextSizeLevelSnapshot, getTextSizeLevelSnapshot),
  setTextSizeLevel,
];

export default useTextSizeLevel;
